import * as types from '../mutation-types'
import { getKeyAccountPartnerProfile, getPartnerProfile } from '@/store/api/partner'

const state = {
  ka_profile: null,
  kaProfileLoaded: false,
  partner_profile: null
}

const getters = {
  kaProfile: (state) => state.ka_profile,
  partnerProfile: (state) => state.partner_profile
}

const actions = {
  getKeyAccountProfile({ commit }, value) {
    return new Promise((resolve, reject) => {
      getKeyAccountPartnerProfile(value)
        .then((response) => {
          if (response && response.ka_profile) {
            commit(types.SET_KEY_ACCOUNT_PROFILE, response.ka_profile)
            resolve(response)
          }
        })
        .catch((e) => {
          const error = (e && e.response) || null
          reject(error)
        })
        .finally(() => {
          commit(types.SET_KEY_ACCOUNT_PROFILE_LOADED, true)
        })
    })
  },
  getPartnerProfile({ commit }, value) {
    return new Promise((resolve, reject) => {
      getPartnerProfile(value)
        .then((response) => {
          if (response) {
            commit(types.SET_PARTNER_PROFILE, response.data)
            resolve(response.data)
          }
        })
        .catch((e) => {
          const error = (e && e.response) || null
          reject(error)
        })
    })
  }
}

const mutations = {
  [types.SET_KEY_ACCOUNT_PROFILE](state, value) {
    state.ka_profile = value
  },
  [types.SET_KEY_ACCOUNT_PROFILE_LOADED](state, value) {
    state.kaProfileLoaded = value
  },
  [types.SET_PARTNER_PROFILE](state, value) {
    state.partner_profile = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
